<template>
	<div id="login_index">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<!-- 第一行标题装饰条 -->
				<div class="d-flex jc-center title_bg">
					<div class="title">
						<span class="title-text">&#9658; {{ title }}</span>
					</div>
				</div>
				<!-- 登录开始 -->
				<div class="container">
					<div class="row">
						<div class="text-center">
							<h1>登录</h1>
						</div>
						<div class="tip mb-2">
							用户名
						</div>
						<div class="mb-3">
							<input type="text" class="form-control" placeholder="请输入用户名" v-model="userName">
						</div>
						<div class="tip mb-2">
							密码
						</div>
						<div class="mb-3">
							<input type="password" class="form-control" placeholder="请输入密码" v-model="password">
						</div>
						<div class="tip mb-2">
							验证码
						</div>
						<div>
							<input type="text" class="form-control w-60 float-l" placeholder="请输入右侧结果" v-model="userCode">
							<div class="w-35 float-r">
								<span id="code" class="code" :style="{ color: ranColor1 }" @click="initCode()">
									<span :style="{ color: ranColor2 }"> {{ num1 }} </span> + <span :style="{ color: ranColor3 }"> {{ num2 }} </span> = ?
								</span>
							</div>
						</div>
						<div class="clearfix"></div>
						<div class="btn mt-5">
							<el-button class="cancel_btn" :plain="true" @click="cancel">重置</el-button>
							<el-button class="login_btn" :plain="true" @click="login">登录</el-button>
						</div>
					</div>
				</div>
				<!-- 登录结束 -->
			</div>
		</dv-full-screen-container>
	</div>
</template>
<script>
var storage = window.localStorage;
var region = storage.getItem("region");

export default {
	data() {
		return {
			loading: true,
			title: '',
			code: 9999,
			ranColor1: '',
			ranColor2: '',
			ranColor3: '',
			num1: '',
			num2: '',
			userName: '',
			password: '',
			userCode: '',
			fullscreen: false,
			screenName: "返回"
		};
	},
	mounted() {
		this.cancelLoading();
		this.initData();
		this.initCode();
	},
	methods: {
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		initData() {
			let _this = this;
			this.$http.get("/dataView/getNameByRedion?regionId=" + region).then(res => {
				if (res.data.code === 200) {
					_this.title = res.data.result + '教育局';
				}
			});
		},
		initCode() {
			//随机生成颜色
			var ranColor1 = '#' + ('00000' + (Math.random() * 0x1000000 << 0).toString(16)).slice(-6);
			var ranColor2 = '#' + ('00000' + (Math.random() * 0x1000000 << 0).toString(16)).slice(-6);
			var ranColor3 = '#' + ('00000' + (Math.random() * 0x1000000 << 0).toString(16)).slice(-6);
			var num1 = Math.floor(Math.random() * 10);
			var num2 = Math.floor(Math.random() * 10);

			this.ranColor1 = ranColor1;
			this.ranColor2 = ranColor2;
			this.ranColor3 = ranColor3;
			this.num1 = num1;
			this.num2 = num2;
			this.code = num1 + num2;
		},
		login() {
			let _this = this;
			var userName = _this.userName;
			if (userName == '') {
				this.$message({ message: '请输入用户名!', type: 'error', customClass: 'customClass', offset: 500 });
				return false;
			}
			var password = _this.password;
			if (password == '') {
				this.$message({ message: '请输入密码!', type: 'error', customClass: 'customClass', offset: 500 });
				return false;
			}
			var userCode = _this.userCode;
			if (password == '') {
				this.$message({ message: '请输入验证码!', type: 'error', customClass: 'customClass', offset: 500 });
				return false;
			}
			var code = _this.code;
			if (userCode != code) {
				this.$message({ message: '请输入正确的验证码!', type: 'error', customClass: 'customClass', offset: 500 });
				return false;
			}
			//提交登录
			this.$http.get("/dataView/edu/login?userName=" + userName + "&password=" + password + "&regionId=" + region).then(res => {
				if (res.data.code === 200) {
					this.$router.push({ path: '/dataView/appIndex', query: { area: region, userId: userName } });
				} else {
					this.$message({ message: res.data.msg, type: 'error', customClass: 'customClass', offset: 500 });
				}
			});
		},
		cancel() {
			this.userName = '';
			this.password = '';
			this.userCode = '';
		}
	},
	// 注意在vue实例销毁前，清除我们的定时器。
	destroyed() {

	}
};
</script>

<style lang="scss">
#login_index {
	background-color: #181b37;
	width: 100%;
	min-height: 100vh;
	background-image: url("../../assets/img/login_bg.gif");
	background-size: 100% 100%;
	background-color: #181b37;

	.bg {
		padding: 0.2rem 0.2rem 0 0.2rem;
		background-position: center center;
	}

	.title_bg {
		width: 100%;
		height: 8vh;
		background: url("../../assets/img/indextit_bg.png") center no-repeat;

		.title {
			width: 100%;
			text-align: left;

			.title-text {
				display: inline-block;
				font-size: 0.25rem !important;
				font-weight: bold;
				line-height: 0.25rem;
				margin-left: 0;
				margin-top: 0.25rem;
				background-image: linear-gradient(135deg, #55ffff, #54c3ff);
				-webkit-background-clip: text;
				color: transparent;
			}
		}
	}

	.w-60 {
		width: 60% !important;
	}

	.w-40 {
		width: 40% !important
	}

	.w-35 {
		width: 35% !important
	}

	.d-inlneblock {
		display: inline-block;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 10px 20px;
		font-size: 16px;
		font-weight: 400;
		line-height: 1.5;
		color: #666;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid #ced4da;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border-radius: .1rem;
		-webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
		transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
		transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
		transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
	}

	input:-moz-placeholder,
	textarea:-moz-placeholder {
		color: #03b4ff;
	}

	input:-ms-input-placeholder,
	textarea:-ms-input-placeholder {
		color: #03b4ff;
	}

	input::-webkit-input-placeholder,
	textarea::-webkit-input-placeholder {
		color: #03b4ff;
	}

	input,
	.form-control {
		color: #fff;
		background-color: rgba(44, 50, 150, 0.3);
		border-color: #384cbe;
		outline: 0;
	}

	input:focus,
	.form-control:focus {
		color: #03b4ff;
		background-color: rgba(44, 50, 150, 0.3);
		border-color: #384cbe;
		outline: 0;
		-webkit-box-shadow: 0 0 0 1px #384cbe;
		box-shadow: 0 0 0 1px #384cbe
	}

	.container {
		width: 500px;
		padding: 60px;
		border-radius: 10px;
		margin: auto;
		margin-right: 250px;
		margin-top: 180px;
		background: rgba(44, 50, 150, 0.5);
	}

	h1 {
		text-transform: uppercase;
		font-size: 30px;
		font-weight: 700;
		letter-spacing: 0.015em;
		color: #fff;
		margin-bottom: 0.3rem;
	}

	.btn {
		display: flex;
		justify-content: space-between;
	}

	.btn button {
		width: 45%;
		display: inline-block;
		border-radius: 10px;
		padding: 15px 30px;
		letter-spacing: 0.015em;
		font-size: 18px;
		line-height: 1;
		color: #03b4ff;
		background-color: rgba(44, 50, 150, 0.3);
		border: none;
		outline: none;
		-webkit-transition: all 0.4s;
		-moz-transition: all 0.4s;
		-o-transition: all 0.4s;
		transition: all 0.4s;
	}

	.login_btn {
		background: rgba(75, 87, 255, 0.5) !important;
	}

	.tip {
		font-size: 14px;
		text-align: left;
		color: #03b4ff;
	}

	.login_btn:hover,
	.cancel_btn:hover {
		color: #fff;
		background: #32379e !important;
		cursor: pointer;
	}

	.code {
		display: inline-block;
		width: 100%;
		font-weight: bold;
		line-height: 46px;
		font-size: 25px;
		cursor: pointer;
		background: #fff;
		border-radius: 10px;
		padding: 0 12px;
	}

	.customClass {
		min-width: 200px;
	}
}
</style>